import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'terms-of-use',
  path: () => '/terms-of-use',
}

export default ROUTE
